import type { Observable } from 'rxjs';

export enum GalleryItemType {
  PICTURE,
  VIDEO,
  FILE,
  PDF,
}

export interface GalleryItem {
  readonly alt?: string;
  readonly caption?: string;
  readonly fileName: string;
  readonly source: string;
  readonly link?: string;
  readonly linkLabel?: string;
  readonly isExternal?: boolean;
  readonly type: GalleryItemType;
  /** Thumbnail URL source of the gallery item in the media viewer. By default, the source will be used. */
  readonly thumbnailSource?: string;
  /**
   * Download URL of the gallery item in the media viewer. By default, the source will be used.
   * Pass `false` to disable download button.
   */
  readonly downloadUrl?: string | false;
  /** Intrinsic width of the gallery item. */
  readonly width?: number;
  /** Intrinsic height of the gallery item. */
  readonly height?: number;
  readonly uploadDetails?: GalleryItemUploadDetails;

  /** To be inplemented in the showcase card */
  readonly showcaseTitle?: string;
  readonly showcaseSubtitle?: string;
  readonly showcaseLink?: string;
  readonly blurHash?: string;
}

export interface GalleryItemUploadDetails {
  progress$: Observable<number>;
  done: boolean;
}
